export const tcUnloadEvents = (e) => {
    e = e || window.event;
    if (e) {
        e.returnValue = "Sicuro di volere abbondonare la pagina?";
        window.tC.event.dropOffNoDati();
}
    return "Sicuro di volere abbondonare la pagina?";
};